import loadable from '@loadable/component';
import {AiOutlineFileText} from '@react-icons/all-files/ai/AiOutlineFileText';
import {AiOutlinePaperClip} from '@react-icons/all-files/ai/AiOutlinePaperClip';
import {AiOutlineUser} from '@react-icons/all-files/ai/AiOutlineUser';
import {AiOutlineLock} from '@react-icons/all-files/ai/AiOutlineLock';
import {AiOutlineCloseCircle} from '@react-icons/all-files/ai/AiOutlineCloseCircle';
import {
    CEREMONY_DOCUMENT_PATH,
    CEREMONY_WELCOME_PATH,
    CEREMONY_ATTACHMENT_PATH,
    CEREMONY_F2F_PATH,
    CEREMONY_SUMMARY_PATH,
    CEREMONY_2FA_SMS_PATH,
    CEREMONY_2FA_QNA_PATH,
    CEREMONY_DECLINED_PATH
} from '@constants/index';

const routes = [
    {
        path: `${CEREMONY_DOCUMENT_PATH}/:documentId`,
        component: loadable(
            () => import(/* webpackChunkName: "signer-ui-document" */ '../components/SignerUi/SigningDocumentView/SigningDocumentView')
        ),
        titleKey: 'signerUI.document.title',
        Icon: AiOutlineFileText,
        exact: true,
        isEnabled: () => true
    },
    {
        path: CEREMONY_WELCOME_PATH,
        component: loadable(
            () => import(/* webpackChunkName: "signer-ui-welcome" */ '../components/SignerUi/Welcome/Welcome')
        ),
        titleKey: 'signerUI.welcome.title',
        Icon: AiOutlineFileText,
        exact: true,
        isEnabled: () => true, // Welcome component always available
        isLeftMenuVisible: false
    },
    {
        path: `${CEREMONY_ATTACHMENT_PATH}/:attachmentId`,
        component: loadable(
            () => import(/* webpackChunkName: "signer-ui-attachment" */ '../components/SignerUi/UploadAttachment/UploadAttachment')
        ),
        titleKey: 'signerUI.attachment.title',
        Icon: AiOutlinePaperClip,
        exact: true,
        isEnabled: () => true // Attachments component always available
    },
    {
        path: CEREMONY_F2F_PATH,
        component: loadable(
            () => import(/* webpackChunkName: "signer-ui-f2f" */ '../components/SignerUi/FaceToFace/FaceToFace')
        ),
        titleKey: 'signerUI.faceToFace.title',
        Icon: AiOutlineUser,
        exact: true,
        isEnabled: () => true,
        isLeftMenuVisible: false
    },
    {
        path: CEREMONY_SUMMARY_PATH,
        component: loadable(
            () => import(/* webpackChunkName: "signer-ui-summary" */ '../components/SignerUi/pages/TransactionSummary/TransactionSummary')
        ),
        titleKey: 'signerUI.summary.title',
        exact: true,
        isEnabled: () => true,
        isLeftMenuVisible: false
    },
    {
        path: CEREMONY_2FA_SMS_PATH,
        component: loadable(
            () => import(/* webpackChunkName: "signer-ui-2fa-sms" */ '../components/SignerUi/2FA/Sms')
        ),
        titleKey: 'signerUI.2fa.sms.title',
        Icon: AiOutlineLock,
        exact: true,
        isEnabled: () => true,
        isLeftMenuVisible: false
    },
    {
        path: CEREMONY_2FA_QNA_PATH,
        component: loadable(
            () => import(/* webpackChunkName: "signer-ui-2fa-qna" */ '../components/SignerUi/2FA/Qna')
        ),
        titleKey: 'signerUI.2fa.qna.title',
        Icon: AiOutlineLock,
        exact: true,
        isEnabled: () => true,
        isLeftMenuVisible: false
    },
    {
        path: CEREMONY_DECLINED_PATH,
        component: loadable(
            () => import(/* webpackChunkName: "signer-ui-declined" */ '../components/SignerUi/Declined/Declined')
        ),
        titleKey: 'signerUI.declined.title',
        Icon: AiOutlineCloseCircle,
        exact: true,
        isEnabled: () => true,
        isLeftMenuVisible: false
    }
];

export default routes;
